import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_k2cxrcr92s: FaireBrandEntity = {
  token: "b_k2cxrcr92s",
  type: "brand",
  name: "Frem",
  avatarUrl:
    "https://cdn.faire.com/fastly/38ff3805f7573b4c24d425482a1d43d688185eeba1639c606cbfb488e8296d1b.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/e9168597da9d5cf32d0e0ebb836926d8be85c1c0fc851dd268f95277d0b37154.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/38ff3805f7573b4c24d425482a1d43d688185eeba1639c606cbfb488e8296d1b.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e9168597da9d5cf32d0e0ebb836926d8be85c1c0fc851dd268f95277d0b37154.jpeg",
  location: "New York, NY, USA",
  minimumOrderDollars: 208,
  rating: 4.9,
  reviewCount: 260,
  isTopShop: true,
  isInsider: true,
  description:
    "Frem is a New York–based fashion jewelry and accessories company that combines the creative vision of a design house with the scale and efficiency of a manufacturer. We specialize in trend-forward collections and private label development, serving a global network of retailers, wholesalers, department stores, and buying offices.\n\nAt Frem, we don’t just follow trends—we anticipate them. Our in-house design team tracks seasonal shifts, emerging global styles, and market demand to deliver fresh, commercially viable designs. Whether you're sourcing for a boutique, launching a private label, or building a seasonal assortment, we offer ready-made and fully customized solutions.\n\nWhat sets us apart is our fully integrated model. With design and production under one roof, we move faster, stay flexible, and offer competitive pricing. We produce samples in 2–3 weeks and full production in 4–6 weeks, with low minimums—120 pieces for jewelry and 300 for other accessories—making it easy for brands of all sizes to get started.\n\nAs part of our sustainability efforts, we are transitioning to eco-friendly tags across all products, reducing environmental impact while maintaining quality. We also support local communities through ethical sourcing, small-batch production, and donation initiatives that reduce waste and give back.\n\nIf you're looking for a design-driven, cost-efficient, and reliable partner, we’d love to hear from you.\n\n",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:40.049Z",
    importedBy: "entity-db-cli",
  },
};
